import React from "react";
import { Box, Container, Typography } from "@mui/material";
import Flashcards from "../Flashcards/Flashcards";


const letters = {
	"ア": "a",
	"イ": "i",
	"ウ": "u",
	"エ": "e",
	"オ": "o",
	"カ": "ka",
	"キ": "ki",
	"ク": "ku",
	"ケ": "ke",
	"コ": "ko",
	"サ": "sa",
	"シ": "shi",
	"ス": "su",
	"セ": "se",
	"ソ": "so",
	"タ": "ta",
	"チ": "chi",
	"ツ": "tsu",
	"テ": "te",
	"ト": "to",
	"ナ": "na",
	"ニ": "ni",
	"ヌ": "nu",
	"ネ": "ne",
	"ノ": "no",
	"ハ": "ha",
	"ヒ": "hi",
	"フ": "fu",
	"ヘ": "he",
	"ホ": "ho",
	"マ": "ma",
	"ミ": "mi",
	"ム": "mu",
	"メ": "me",
	"モ": "mo",
	"ヤ": "ya",
	"ユ": "yu",
	"ヨ": "yo",
	"ラ": "ra",
	"リ": "ri",
	"ル": "ru",
	"レ": "re",
	"ロ": "ro",
	"ワ": "wa",
	"ヲ": "wo",
	"ン": "n",
	"ガ": "ga",
	"ギ": "gi",
	"グ": "gu",
	"ゲ": "ge",
	"ゴ": "go",
	"ザ": "za",
	"ジ": "ji",
	"ズ": "zu",
	"ゼ": "ze",
	"ゾ": "zo",
	"ダ": "da",
	"ヂ": "dji",
	"ヅ": "dzu",
	"デ": "de",
	"ド": "do",
	"バ": "ba",
	"ビ": "bi",
	"ブ": "bu",
	"ベ": "be",
	"ボ": "bo",
	"パ": "pa",
	"ピ": "pi",
	"プ": "pu",
	"ペ": "pe",
	"ポ": "po",
	"キャ": "kya",
	"キュ": "kyu",
	"キョ": "kyo",
	"シャ": "sha",
	"シュ": "shu",
	"ショ": "sho",
	"チャ": "cha",
	"チュ": "chu",
	"チョ": "cho",
	"ニャ": "nya",
	"ニュ": "nyu",
	"ニョ": "nyo",
	"ヒャ": "hya",
	"ヒュ": "hyu",
	"ヒョ": "hyo",
	"ミャ": "mya",
	"ミュ": "myu",
	"ミョ": "myo",
	"リャ": "rya",
	"リュ": "ryu",
	"リョ": "ryo",
	"ギャ": "gya",
	"ギュ": "gyu",
	"ギョ": "gyo",
	"ジャ": "ja",
	"ジュ": "ju",
	"ジョ": "jo",
	"ビャ": "bya",
	"ビュ": "byu",
	"ビョ": "byo",
	"ピャ": "pya",
	"ピュ": "pyu",
	"ピョ": "pyo",
	"a": "ア",
	"i": "イ",
	"u": "ウ",
	"e": "エ",
	"o": "オ",
	"ka": "カ",
	"ki": "キ",
	"ku": "ク",
	"ke": "ケ",
	"ko": "コ",
	"sa": "サ",
	"shi": "シ",
	"su": "ス",
	"se": "セ",
	"so": "ソ",
	"ta": "タ",
	"chi": "チ",
	"tsu": "ツ",
	"te": "テ",
	"to": "ト",
	"na": "ナ",
	"ni": "ニ",
	"nu": "ヌ",
	"ne": "ネ",
	"no": "ノ",
	"ha": "ハ",
	"hi": "ヒ",
	"fu": "フ",
	"he": "ヘ",
	"ho": "ホ",
	"ma": "マ",
	"mi": "ミ",
	"mu": "ム",
	"me": "メ",
	"mo": "モ",
	"ya": "ヤ",
	"yu": "ユ",
	"yo": "ヨ",
	"ra": "ラ",
	"ri": "リ",
	"ru": "ル",
	"re": "レ",
	"ro": "ロ",
	"wa": "ワ",
	"wo": "ヲ",
	"n": "ン",
	"ga": "ガ",
	"gi": "ギ",
	"gu": "グ",
	"ge": "ゲ",
	"go": "ゴ",
	"za": "ザ",
	"ji": "ジ",
	"zu": "ズ",
	"ze": "ゼ",
	"zo": "ゾ",
	"da": "ダ",
	"dji": "ヂ",
	"dzu": "ヅ",
	"de": "デ",
	"do": "ド",
	"ba": "バ",
	"bi": "ビ",
	"bu": "ブ",
	"be": "ベ",
	"bo": "ボ",
	"pa": "パ",
	"pi": "ピ",
	"pu": "プ",
	"pe": "ペ",
	"po": "ポ",
	"kya": "キャ",
	"kyu": "キュ",
	"kyo": "キョ",
	"sha": "シャ",
	"shu": "シュ",
	"sho": "ショ",
	"cha": "チャ",
	"chu": "チュ",
	"cho": "チョ",
	"nya": "ニャ",
	"nyu": "ニュ",
	"nyo": "ニョ",
	"hya": "ヒャ",
	"hyu": "ヒュ",
	"hyo": "ヒョ",
	"mya": "ミャ",
	"myu": "ミュ",
	"myo": "ミョ",
	"rya": "リャ",
	"ryu": "リュ",
	"ryo": "リョ",
	"gya": "ギャ",
	"gyu": "ギュ",
	"gyo": "ギョ",
	"ja": "ジャ",
	"ju": "ジュ",
	"jo": "ジョ",
	"bya": "ビャ",
	"byu": "ビュ",
	"byo": "ビョ",
	"pya": "ピャ",
	"pyu": "ピュ",
	"pyo": "ピョ",
};


function Katakana() {
	return (
		<>
			<Container maxWidth="sm">
				<Box mt={5} sx={{ textAlign: "center" }}>
					<section>
						<Typography variant="h4">Katakana</Typography>
					</section>
					<section>
						<Flashcards dictionary={letters} />
					</section>
				</Box>
			</Container>
		</>
	);
}

export default Katakana;